import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {NewSubscriptionStep3Page} from './new-subscription-step3';

import {BrMaskerModule} from 'brmasker-ionic-3';

@NgModule({
  declarations: [
    NewSubscriptionStep3Page,
  ],
  imports: [
    IonicPageModule.forChild(NewSubscriptionStep3Page),
    BrMaskerModule,
  ],
  exports: [
    NewSubscriptionStep3Page
  ]
})
export class NewSubscriptionStep3PageModule {
}



// WEBPACK FOOTER //
// ./src/pages/new-subscription-step3/new-subscription-step3.module.ts